import Axios from 'axios';
import { Auth } from 'aws-amplify';
import { redirectAfterSessionLoss } from '@seller-hermes/app/auth-session-expiry';
import { hasCachedCognitoSession } from '@seller-hermes/utils/cognito-session-cache';

const api = Axios.create({
  baseURL: process.env.NX_API_URL,
});

api.interceptors.request.use(async (config) => {
  if (!hasCachedCognitoSession()) return config;

  try {
    const auth = await Auth.currentSession();
    const token = auth.getIdToken().getJwtToken();

    if (token) {
      config.headers
        ? (config.headers.authorization = `Bearer ${token}`)
        : (config.headers = { authorization: `Bearer ${token}` });
    }
  } catch {
    // A previously cached session that no longer resolves means the
    // session was invalidated elsewhere (LOG-475, Gap 3) — same fallback
    // as dashboard-web's utils/api.ts.
    redirectAfterSessionLoss();
    return config;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      redirectAfterSessionLoss();
    }
    return Promise.reject(error);
  },
);

export default api;
